import { constants } from "../../constants";
const metaDataReducer = (state = {}, action) => {
    switch (action.type) {
        case constants.IS_META:
            return action.payload;
        default:
            return state;
    }
}
export default metaDataReducer